import { Col, Form, Row } from 'antd';
import FormCheckBox from '../../../../components/Inputs/FormCheckBox';

const BiddingAddModalCard = ({ providersDetails, name }) => {
  return (
    <Form.Item>
      <div className="paper-container border-muted mb-15 ant-collapse-header">
        <div className="py-10">
          <Row gutter={10} className="flex-nowrap px-15" justify="start" align="start">
            <Col sm={1}>
              <FormCheckBox
                name={[name, 'isChecked']}
                className="m-0"
                checkBoxClass="normal-checkbox"
                checked={providersDetails?.isChecked}
              />
            </Col>

            <Col sm={5} data-testid="bidding-add-modal-card-transportation-provider">
              <p className="m-0 fw-400 f-12 color-label"> Transportation Provider </p>
              <p className="mt-1 fw-500 f-13 color-dark"> {providersDetails?.transportationProvider || ''}</p>
            </Col>
            <Col sm={3} data-testid="bidding-add-modal-card-scac">
              <p className="m-0 fw-400 f-12 color-label">SCAC </p>
              <p className="mt-1 fw-500 f-13 color-dark">{providersDetails?.scac || ''}</p>
            </Col>

            <Col sm={3} data-testid="bidding-add-modal-card-short-name">
              <p className="m-0 fw-400 f-12 color-label">Short Name</p>
              <p className="mt-1 fw-500 f-13 color-dark">{providersDetails?.shortName || ''}</p>
            </Col>
            <Col sm={3} data-testid="bidding-add-modal-card-status">
              <p className="m-0 fw-400 f-12 color-label">Status</p>
              <p className="mt-1 fw-500 f-13 color-dark">{providersDetails?.status || ''}</p>
            </Col>
            <Col sm={7} data-testid="bidding-add-modal-card-email">
              <p className="m-0 fw-400 f-12 color-label">Email</p>
              <p className="mt-1 fw-500 f-13 color-dark">{providersDetails?.email || ''}</p>
            </Col>
          </Row>
        </div>
      </div>
    </Form.Item>
  );
};

export default BiddingAddModalCard;
